import React, {Component, useState} from 'react';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';

import {
    Accordion,
    AccordionItem,
    AccordionSkeleton, Button,
    MultiSelect,
    RadioButton
} from "carbon-components-react";
import {Undo16} from "@carbon/icons-react";
import BasicDateTimePicker from "../DatePicker";

export default class extends Component {

    state = {
        isOppenedSubmit: false,
        skuisOpend: true,
        skuDetailsisOpenend: true,
        form: {
            dateStart: "",
            dateEnd: "",
            sku: [],
            brand: [],
            category: [],
            hero: [],
            majorCategory: [],
            abcd: [],
            subCategory: [],
            plcLocal: [],
            chanel: [],
        }
    };

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

    }

    removeDuplicates(array, key) {
        return array.reduce((accumulator, element) => {
            if (!accumulator.find(el => el[key] === element[key])) {
                accumulator.push(element);
            }
            return accumulator;
        }, []);
    }

    async handleChange(e) {
        //const name = event.target.name;
        //console.log(name);
        const {name, value} = e.target;
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [name]: value
            }
        }));
        //console.log(this.state);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        //Your code here. For example,
        //alert("Form submitted");
        //console.log(this.state.form);
        localStorage.setItem('formFilter', JSON.stringify(this.state.form));
        window.location.href = '/ij/plan_edit'
    }

    handleSetClear = (e) => {
        e.preventDefault();
        this.setState({
            isOppenedSubmit: false,
            skuisOpend: true,
            skuDetailsisOpenend: true,
            form: {
                dateStart: "",
                dateEnd: "",
                sku: [],
                brand: [],
                category: [],
                hero: [],
                majorCategory: [],
                abcd: [],
                subCategory: [],
                plcLocal: [],
                chanel: [],
            }
        });

    }


    render() {
        const {data, isLoading} = this.props;
        const {form, skuisOpend, skuDetailsisOpenend} = this.state;
        let sku = [];
        let brand = [];
        let category = [];
        let hero = [];
        let majorCategory = [];
        let abcd = [];
        let subCategory = [];
        let plcLocal = [];
        if (data.length > 0) {
            data.forEach(dados => {
                sku.push({id: dados['sku'], text: dados['sku']});
                if (dados['marca'] !== "")
                    brand.push({id: dados['marca'], text: dados['marca']});
                if (dados['category_sku'] !== "")
                    category.push({id: dados['category_sku'], text: dados['category_sku']});
                if (dados['hero'] !== "")
                    hero.push({id: dados['hero'], text: dados['hero']});
                if (dados['categoria_principal_sku'] !== "")
                    majorCategory.push({id: dados['categoria_principal_sku'], text: dados['categoria_principal_sku']});
                if (dados['abcd'] !== "")
                    abcd.push({id: dados['abcd'], text: dados['abcd']});
                if (dados['sub_categoria_sku'] !== "")
                    subCategory.push({id: dados['sub_categoria_sku'], text: dados['sub_categoria_sku']});
                if (dados['plc_localsku'] !== "")
                    plcLocal.push({id: dados['plc_localsku'], text: dados['plc_local']});
            });
            sku = this.removeDuplicates(sku, 'id');
            brand = this.removeDuplicates(brand, 'id');
            category = this.removeDuplicates(category, 'id');
            hero = this.removeDuplicates(hero, 'id');
            majorCategory = this.removeDuplicates(majorCategory, 'id');
            abcd = this.removeDuplicates(abcd, 'id');
            subCategory = this.removeDuplicates(subCategory, 'id');
            plcLocal = this.removeDuplicates(plcLocal, 'id');
        }
        let step2 = false;
        let step3 = true;
        let buttonD = true;
        if (form.dateStart !== "" && form.dateEnd !== "") {
            step2 = false;
        }
        if (form.sku.length > 0 || form.brand.length > 0 || form.category.length > 0 || form.hero.length > 0 || form.majorCategory.length > 0 || form.abcd.length > 0 || form.subCategory.length > 0 || form.plcLocal.length > 0) {
            step3 = false;
        }
        if (form.chanel.length > 0) buttonD = false;

        return (
            <div>
                <form>
                    <div className="bx--row bx--fieldset">
                        <div className="bx--col-md-6 bx--col-lg-7 content-pt-1"><p>To generate a report you need to
                            select
                            Period, SKU
                            and Channel options.</p></div>
                        <div className="bx--col-md-2 bx--col-lg-3 content-align-center">
                            <Button onClick={e => {
                                this.handleSubmit(e)
                            }} kind='primary'
                                    disabled={buttonD}>Generate
                                report</Button>
                            <span className="content-ml-10">
                            <Button
                                hasIconOnly
                                renderIcon={Undo16}
                                tooltipAlignment="center"
                                tooltipPosition="bottom"
                                iconDescription="Reset"
                                kind='secondary'
                                onClick={e => {
                                    this.handleSetClear(e)
                                }}
                            />
                            </span>
                        </div>
                    </div>
                    {isLoading ? (
                        <AccordionSkeleton/>
                    ) : (
                        <Accordion>
                            <AccordionItem open="true" title="1. Period">
                                <div className={"clearfix"}>
                                    <div className={"div-date"}>
                                        <BasicDateTimePicker />
                                    </div>
                                    <div className={"div-date"}>

                                    </div>
                                </div>
                            </AccordionItem>
                            <AccordionItem disabled={step2} open={step2} title="2. SKU">
                                <div class="clearfix">
                                    <div className="bx-row">
                                        <div className="width-54">
                                            <RadioButton
                                                id="radio-x"
                                                labelText="SKU"
                                                value="sku-code"
                                                name="sku_choose"
                                                onClick={(evt) => {
                                                    this.setState({'skuisOpend': false, 'skuDetailsisOpenend': true})
                                                }}
                                            />
                                        </div>
                                        <div className="bx-row">
                                            <div className="width-28 float-l">
                                                &nbsp;
                                            </div>
                                            <div className="bx--col-md-3 float-l  no-p-left">
                                                <MultiSelect.Filterable
                                                    disabled={skuisOpend}
                                                    useTitleInItem={false}
                                                    id="sku"
                                                    name="sku"
                                                    label="SKU"
                                                    placeholder="SKU"
                                                    invalid={false}
                                                    invalidText="Invalid Selection"
                                                    items={sku}
                                                    initialSelectedItems={form.sku}
                                                    itemToString={(item) => (item ? item.text : '')}
                                                    onChange={(evt) => {
                                                        this.setState(prevState => ({
                                                            form: {
                                                                ...prevState.form,
                                                                'sku': evt.selectedItems.map((item) => {
                                                                    return item.id
                                                                })
                                                            }
                                                        }))
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="bx-row padding-b-40">
                                            <div className={"clearfix"}></div>
                                    </div>

                                    <div class="bx-row">
                                        <div class="width-120">
                                            <RadioButton
                                                id="radio-y"
                                                labelText="SKU attributes"
                                                value="standard"
                                                name="sku_choose"
                                                className={"radio-sku-attributes"}
                                                onClick={(evt) => {
                                                    this.setState({'skuisOpend': true, 'skuDetailsisOpenend': false})
                                                }}

                                            />
                                        </div>
                                        <div class="bx-row">
                                            <div class="width-28 float-l">
                                                &nbsp;
                                            </div>
                                            <div class="bx--col-md-3 float-l  no-p-left">
                                                <MultiSelect.Filterable
                                                    disabled={skuDetailsisOpenend}
                                                    useTitleInItem={false}
                                                    id="brand"
                                                    name="brand"
                                                    label="Brand"
                                                    placeholder="Brand"
                                                    invalid={false}
                                                    invalidText="Invalid Selection"
                                                    items={brand}
                                                    initialSelectedItems={form.brand}
                                                    itemToString={(item) => (item ? item.text : '')}
                                                    onChange={(evt) => {
                                                        this.setState(prevState => ({
                                                            form: {
                                                                ...prevState.form,
                                                                'brand': evt.selectedItems.map((item) => {
                                                                    return item.id
                                                                })
                                                            }
                                                        }))
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="bx-row content-align-left clearfix p-bottom-30">
                                        <div className="width-28 float-l">
                                            &nbsp;
                                        </div>
                                        <div className="bx--col-md-3 float-l clearfix no-p-left">
                                            <MultiSelect.Filterable
                                                disabled={skuDetailsisOpenend}
                                                useTitleInItem={false}
                                                id="category"
                                                name="category"
                                                label="CATEGORY"
                                                placeholder="CATEGORY"
                                                invalid={false}
                                                invalidText="Invalid Selection"
                                                items={category}
                                                initialSelectedItems={form.category}
                                                itemToString={(item) => (item ? item.text : '')}
                                                onChange={(evt) => {
                                                    this.setState(prevState => ({
                                                        form: {
                                                            ...prevState.form,
                                                            'category': evt.selectedItems.map((item) => {
                                                                return item.id
                                                            })
                                                        }
                                                    }))
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="bx-row content-align-left clearfix p-bottom-30">
                                        <div className="width-28 float-l">
                                            &nbsp;
                                        </div>
                                        <div className="bx--col-md-3 float-l clearfix no-p-left">
                                            <MultiSelect.Filterable
                                                disabled={skuDetailsisOpenend}
                                                useTitleInItem={false}
                                                id="hero"
                                                name="hero"
                                                label="HERO"
                                                placeholder="HERO"
                                                invalid={false}
                                                invalidText="Invalid Selection"
                                                items={hero}
                                                initialSelectedItems={form.hero}
                                                itemToString={(item) => (item ? item.text : '')}
                                                onChange={(evt) => {
                                                    this.setState(prevState => ({
                                                        form: {
                                                            ...prevState.form,
                                                            'hero': evt.selectedItems.map((item) => {
                                                                return item.id
                                                            })
                                                        }
                                                    }))
                                                }}
                                            />
                                        </div>
                                        <div className="width-28 float-l">
                                            &nbsp;
                                        </div>
                                        <div className="bx--col-md-3 float-l clearfix no-p-left">
                                            <MultiSelect.Filterable
                                                disabled={skuDetailsisOpenend}
                                                useTitleInItem={false}
                                                id="majorCategory"
                                                name="majorCategory"
                                                label="MAJOR CATEGORY"
                                                placeholder="MAJOR CATEGORY"
                                                invalid={false}
                                                invalidText="Invalid Selection"
                                                items={majorCategory}
                                                initialSelectedItems={form.majorCategory}
                                                itemToString={(item) => (item ? item.text : '')}
                                                onChange={(evt) => {
                                                    this.setState(prevState => ({
                                                        form: {
                                                            ...prevState.form,
                                                            'majorCategory': evt.selectedItems.map((item) => {
                                                                return item.id
                                                            })
                                                        }
                                                    }))
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="bx-row content-align-left clearfix p-bottom-30">
                                        <div className="width-28 float-l">
                                            &nbsp;
                                        </div>
                                        <div className="bx--col-md-3 float-l clearfix no-p-left">
                                            <MultiSelect.Filterable
                                                disabled={skuDetailsisOpenend}
                                                useTitleInItem={false}
                                                id="abcd"
                                                name="abcd"
                                                label="ABCD"
                                                placeholder="ABCD"
                                                invalid={false}
                                                invalidText="Invalid Selection"
                                                items={abcd}
                                                initialSelectedItems={form.abcd}
                                                itemToString={(item) => (item ? item.text : '')}
                                                onChange={(evt) => {
                                                    this.setState(prevState => ({
                                                        form: {
                                                            ...prevState.form,
                                                            'abcd': evt.selectedItems.map((item) => {
                                                                return item.id
                                                            })
                                                        }
                                                    }))
                                                }}
                                            />
                                        </div>
                                        <div className="width-28 float-l">
                                            &nbsp;
                                        </div>
                                        <div className="bx--col-md-3 float-l clearfix no-p-left">
                                            <MultiSelect.Filterable
                                                disabled={skuDetailsisOpenend}
                                                useTitleInItem={false}
                                                id="subCategory"
                                                name="subCategory"
                                                label="SUB CATEGORY"
                                                placeholder="SUB CATEGORY"
                                                invalid={false}
                                                invalidText="Invalid Selection"
                                                items={subCategory}
                                                initialSelectedItems={form.subCategory}
                                                itemToString={(item) => (item ? item.text : '')}
                                                onChange={(evt) => {
                                                    this.setState(prevState => ({
                                                        form: {
                                                            ...prevState.form,
                                                            'subCategory': evt.selectedItems.map((item) => {
                                                                return item.id
                                                            })
                                                        }
                                                    }))
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="bx-row content-align-left clearfix p-bottom-30">
                                        <div className="width-28 float-l">
                                            &nbsp;
                                        </div>
                                        <div className="bx--col-md-3 float-l clearfix no-p-left">
                                            <MultiSelect.Filterable
                                                disabled={skuDetailsisOpenend}
                                                useTitleInItem={false}
                                                id="plcLocal"
                                                name="plcLocal"
                                                label="PLC LOCAL"
                                                placeholder="PLC LOCAL"
                                                invalid={false}
                                                invalidText="Invalid Selection"
                                                items={plcLocal}
                                                initialSelectedItems={form.plcLocal}
                                                itemToString={(item) => (item ? item.text : '')}
                                                onChange={(evt) => {
                                                    this.setState(prevState => ({
                                                        form: {
                                                            ...prevState.form,
                                                            'plcLocal': evt.selectedItems.map((item) => {
                                                                return item.id
                                                            })
                                                        }
                                                    }))
                                                }}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </AccordionItem>
                            <AccordionItem disabled={step3} open={!step3} title="3. Channel">
                                <div class="clearfix">
                                    <div class="bx-row">
                                        <div class="width-28 float-l">
                                            &nbsp;
                                        </div>
                                        <form onChange={this.handleChange}>
                                            <div class="bx--col-md-3 float-l  no-p-left">
                                                <MultiSelect.Filterable
                                                    useTitleInItem={false}
                                                    id="chanel"
                                                    name="chanel"
                                                    label="CHANEL"
                                                    placeholder="CHANEL"
                                                    invalid={false}
                                                    invalidText="Invalid Selection"
                                                    items={[
                                                        {
                                                            id: 'WHOLESALES',
                                                            text: 'wholesales'
                                                        },
                                                        {
                                                            id: 'BRANDSITE',
                                                            text: 'Brandsite'
                                                        },
                                                        {
                                                            id: 'ONLINE_PARTNERS',
                                                            text: 'Online Partners'
                                                        },
                                                        {
                                                            id: 'FSS',
                                                            text: 'FSS'
                                                        }
                                                    ]}
                                                    initialSelectedItems={form.chanel}
                                                    itemToString={(item) => (item ? item.text : '')}
                                                    onChange={(evt) => {
                                                        this.setState(prevState => ({
                                                            form: {
                                                                ...prevState.form,
                                                                'chanel': evt.selectedItems.map((item) => {
                                                                    return item.id
                                                                })
                                                            }
                                                        }))
                                                    }}
                                                />
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </AccordionItem>
                        </Accordion>
                    )}
                </form>
            </div>
        );
    }
}
